/** Central query key factory for TanStack Query. */

export const queryKeys = {
  notifications: (userId) => ['notifications', userId],
  settings: () => ['settings'],
  constituencies: () => ['constituencies'],
  campaigns: (constituencyId) => ['campaigns', constituencyId],
  records: (constituencyId, campaignId, page, filters) => ['records', constituencyId, campaignId, page, filters],
  recordsBlocks: (constituencyId, campaignId) => ['records', 'blocks', constituencyId, campaignId],
  dashboardStats: (constituencyId, campaignId, threshold) => ['dashboard', 'stats', constituencyId, campaignId, threshold],
  myVotingBoxes: () => ['voting', 'myBoxes'],
  votingBoxes: (campaignId) => ['voting', 'boxes', campaignId],
  votingStats: (campaignId) => ['voting', 'stats', campaignId],
  votingPublicLink: (campaignId) => ['voting', 'publicLink', campaignId],
  turnout: (campaignId, token) => ['turnout', campaignId, token ?? ''],
  publicCampaigns: () => ['turnout', 'campaigns'],
  callerMe: () => ['caller', 'me'],
  callers: (status) => ['callers', status ?? 'all'],
  blockAssignments: (campaignId) => ['blockAssignments', campaignId ?? 'all'],
  callerAssignments: () => ['caller', 'assignments'],
  callerRecords: (campaignId, block, page, search) => ['caller', 'records', campaignId, block, page, search],
  callerStats: (campaignId) => ['caller', 'stats', campaignId],
  mpConfig: () => ['mp', 'config'],
  mpBlocks: () => ['mp', 'blocks'],
  mpStats: () => ['mp', 'stats'],
  mpRequests: (page, filters) => ['mp', 'requests', page, filters],
  mpFilterCampaigns: (constituencyId) => ['mp', 'filterCampaigns', constituencyId],
};
